import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Select from 'react-select';
import InputMask from 'react-input-mask';
import getLocale from '../../../i18n/getLocale';

class ScheduleGradeStaffRemainingAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      modal_props: false,
      loaded: 0,
      staff_id: this.props.staff_id,
      date_start: this.props.date_start,
      date_finish: this.props.date_finish,
      schedule_grade_id: this.props.schedule_grade_id,
      schedule_grade_initials_secondary: this.props.schedule_grade_initials_secondary,
      schedule_grade_initials_vacation: this.props.schedule_grade_initials_vacation,
      types_list: this.props.types_list,
      schedule_initial: null,
      type: null,
    };

    this.add = this.add.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  // Handlers
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
      if (event.value === 'FERIAS') {
        this.setState({schedule_initial: this.state.schedule_grade_initials_vacation[0]});
      } else {
        this.setState({schedule_initial: null});
      }
    }
    this.setState(change);
  }

  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0) || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        staff_id: newProps.staff_id,
        schedule_grade_id: newProps.schedule_grade_id,
        schedule_grade_initials_secondary: newProps.schedule_grade_initials_secondary,
        schedule_grade_initials_vacation: newProps.schedule_grade_initials_vacation,
        types_list: newProps.types_list,
        loaded: 1,
      });
    }
  }

  add(event) {
    event.preventDefault();
    var self = this;
    this.props.handleAlert('', '', 'open');
    var datasave = {
      staff_id: this.state.staff_id,
      schedule_grade_id: this.state.schedule_grade_id,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      type: this.state.type,
      schedule_initial: this.state.schedule_initial,
    };
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/adicionar/alternativo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    var self = this;
    return (
<form onSubmit={self.add}>
  <RequestApi ref={'request_api'} handleLoaded={this.props.handleLoaded} />
  <div className="row">
    <div className="col-md-3">
      <InputMask type="text"  maskChar={null} mask="99/99/9999" name="date_start" className="form-control" placeholder={this.locale.GradesDeEscala.EditarGradeDeEscala.tabForaDaEscala.formulario.placeholder.DataInicial} value={this.state.date_start} onChange={this.handleChange.bind(this, 'date_start')} required />
    </div>
    <div className="col-md-3">
      <InputMask type="text"  maskChar={null} mask="99/99/9999" name="date_finish" className="form-control" placeholder={this.locale.GradesDeEscala.EditarGradeDeEscala.tabForaDaEscala.formulario.placeholder.DataFinal} value={this.state.date_finish} onChange={this.handleChange.bind(this, 'date_finish')} required />
    </div>
    <div className="col-md-3">
      <Select
        className="form-field-name"
        name="type"
        value={self.state.type}
        searchable={true}
        placeholder={this.locale.GradesDeEscala.EditarGradeDeEscala.tabForaDaEscala.formulario.placeholder.Tipo}
        onChange={self.handleSelectChange.bind(self, 'type')}
        options={[
          {value: 'FERIAS', label: this.locale.GradesDeEscala.EditarGradeDeEscala.tabForaDaEscala.formulario.opcoesTipo.FERIAS},
          {value: 'MEDICA', label: this.locale.GradesDeEscala.EditarGradeDeEscala.tabForaDaEscala.formulario.opcoesTipo.MEDICA},
          {value: 'MANUT', label: this.locale.GradesDeEscala.EditarGradeDeEscala.tabForaDaEscala.formulario.opcoesTipo.MANUT},
          {value: 'INS', label: this.locale.GradesDeEscala.EditarGradeDeEscala.tabForaDaEscala.formulario.opcoesTipo.INS},
          {value: 'FORA', label: this.locale.GradesDeEscala.EditarGradeDeEscala.tabForaDaEscala.formulario.opcoesTipo.FORA},
          {value: 'RESERVA', label: this.locale.GradesDeEscala.EditarGradeDeEscala.tabForaDaEscala.formulario.opcoesTipo.RESERVA},
          {value: 'EXTRA', label: this.locale.GradesDeEscala.EditarGradeDeEscala.tabForaDaEscala.formulario.opcoesTipo.EXTRA},
        ]}
        required
      />
    </div>
    <div className="col-md-3">
      <Select
        className="form-field-name"
        name="schedule_initial"
        value={self.state.schedule_initial}
        searchable={true}
        placeholder={this.locale.GradesDeEscala.EditarGradeDeEscala.tabForaDaEscala.formulario.placeholder.Sigla}
        onChange={self.handleSelectChange.bind(self, 'schedule_initial')}
        options={this.state.schedule_grade_initials_secondary}
        required
      />
    </div>
  </div>
  <br/>
  <button className="btn btn-block btn-primary"><i className="fa fa-save fa-fw"></i> {this.locale.general.adicionar}</button>
</form>
    );
  }
}


export default ScheduleGradeStaffRemainingAdd;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeStaffRemainingAdd.js